<template>
  <v-flex v-bind="{ [size]: size !== ''}" v-ripple @click="$emit('click')">
    <v-btn flat block class="text-xs-center bordered" :ripple="false">
      <slot>
      </slot>
    </v-btn>
  </v-flex>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: '',
    },
  },
};
</script>
<style scoped>
  .btn >>> .btn__content:before {
    opacity: 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/ModalBtn.vue